var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"h100 w100",attrs:{"frameborder":"0","name":"showHere","scrolling":"auto","src":_vm.url,"title":"iframe"}})
}
var staticRenderFns = []

export { render, staticRenderFns }